var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "feature-categories-tile",
      attrs: {
        href: `${_vm.category.url}`,
        "data-aos": "flip-up",
        "data-aos-delay": _vm.index * 100
      }
    },
    [
      _vm.category.image
        ? _c("div", {
            directives: [
              {
                name: "lazy",
                rawName: "v-lazy:background-image",
                value: _vm.category.image,
                expression: "category.image",
                arg: "background-image"
              }
            ],
            staticClass: "feature-categories-tile__background-image",
            attrs: { alt: _vm.category.imageAlt }
          })
        : _vm._t("svg"),
      _c("div", { staticClass: "feature-categories-tile__overlay" }),
      _c("div", { staticClass: "feature-categories-tile__text-wrapper" }, [
        _c("h2", { staticClass: "feature-categories-tile__title" }, [
          _c("span", { staticClass: "feature-categories-tile__title-span" }, [
            _vm._v(_vm._s(_vm.category.title)),
            _c(
              "span",
              { staticClass: "feature-categories-tile__icon" },
              [_c("icon", { attrs: { name: "chevron-right", size: "14px" } })],
              1
            )
          ])
        ]),
        _c(
          "p",
          {
            ref: "description",
            staticClass: "feature-categories-tile__description"
          },
          [_vm._v(_vm._s(_vm.category.description))]
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }